import * as echarts from "echarts"
import { bind as bindSizeSensor, clear as clearSizeSensor } from "size-sensor"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chart"]

  chartTargetConnected(target) {
    this.chart = echarts.init(target)

    bindSizeSensor(target, () => {
      if (this.chart) {
        this.chart.resize({ width: "auto", height: "auto" })
      }
    })
  }

  chartTargetDisconnected(target) {
    clearSizeSensor(target)

    if (this.chart) {
      echarts.dispose(this.chart)
      this.chart = null
    }
  }
}
